import { MOCK_ALL_APIS } from "@/constants"
import { TrackPageView } from "./trackPageView.interface"
import { trackPageView } from "./trackPageView"
import { trackPageViewMock } from "./trackPageView.mock"

const resolvedAction: TrackPageView = MOCK_ALL_APIS ? trackPageViewMock : trackPageView
export { resolvedAction as trackPageView }
